import type { AxiosResponse } from "axios";
import axios from "axios";

export const getPublicIp = async (): Promise<string> => {
	try {
		const response: AxiosResponse<string> = await axios.get("https://ipv4.icanhazip.com/");
		return response.data.replace(/(\r\n|\n|\r)/gm, "");
	} catch (error) {
		return "0.0.0.1";
	}
};
